import { EventVm, MatchCoachVm, UpdateEventCommand } from '../../../../utils/api';
import CoachExclusion from './CoachExclusion';

interface OwnProps {
    isHomeTeam: boolean;
    event: UpdateEventCommand;
    coaches: MatchCoachVm[];
    updateEvent: (event: UpdateEventCommand) => void;
    clearEvent: () => void;
    deleteEvent: (event: EventVm) => void;
}

export type Props = OwnProps;

export default CoachExclusion;
